<template>
    <div id="personalCenter">

         <div class="section1">
            <h4>个人信息</h4>
            <el-row>
                <el-col :span="8">
                    <i class="fa fa-product-hunt" style="font-size: 12px;"></i>&nbsp;&nbsp;<label style="width:120px;">昵 称：</label>{{personalData.name}}
                </el-col>
            </el-row> 

            <el-row> 
                 <el-col :span="8">
                    <i class="fa fa-id-badge "></i>&nbsp;&nbsp;<label style="width:120px;">账户名称：</label>{{personalData.accountName}}
                </el-col>
            </el-row> 

            <el-row> 
                <el-col :span="16">
                    <i class="fa fa-mobile " style="font-size: 20px;"></i>&nbsp;&nbsp;<label style="width:120px;">手机号：</label>{{personalData.bindMobile}}
                    <el-button type="primary" style="margin-left: 80px;" @click="resetMobiledialog = true">重 绑</el-button>
                </el-col>
            </el-row> 

            <div v-if="isAgent" >
                <h4>提现配置</h4>
                <el-button type="primary" style="margin-bottom: 10px;"  @click="showEditWithdrawalConfig(null)">新 增</el-button>
                <el-table :data="withdrawalConfigData"  style="width: 100%">
                    <el-table-column label="提现方式">
                        <template slot-scope="scope">
                            {{scope.row.cashType==1?"支付宝":scope.row.cashType==2?"银行卡":"" }}
                        </template>
                    </el-table-column>
                    <el-table-column  prop="bankName" label="银行名称："  width="180"> </el-table-column>
                    <el-table-column  prop="payeeAccount"  label="收款账号" width="180"> </el-table-column>
                    <el-table-column  prop="payeeName"  label="收款人姓名"> </el-table-column>
                    <el-table-column  prop="mobile"  label="手机号"> </el-table-column>
                    <el-table-column  label="当前状态">  
                        <template slot-scope="scope">
                            {{scope.row.enable==1?"启用":"禁用" }}
                        </template>
                    </el-table-column>
                    <el-table-column  label="操作">  
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="showEditWithdrawalConfig(scope.row)">编 辑</el-button>
                            <el-button type="text" size="small"  @click="deleteWithdrawalConfig(scope.row.id)">删 除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>


            <h4>操作</h4>
            <el-row>
                <el-col :span="4">
                    <el-button type="primary"  @click="modifyPwdVisible = true">修改登录密码</el-button>
                </el-col>
                <el-col :span="4" v-if="isAgent">
                    <el-button type="primary"  @click="changePaypassDialog=true">修改支付 / 提现密码</el-button>
                </el-col>
            </el-row> 

        </div>

        <!-- 重绑手机号 -->
        <el-dialog :append-to-body="true"  title="重绑手机号" :visible.sync="resetMobiledialog"  width="600px" @close="cancelResetMobile()" :close-on-click-modal="false">
            <el-form ref="resetMobileForm" :model="resetMobileForm"  :rules="resetMobileRules" label-width="100px">

                <el-form-item label="新手机号"  prop="resetMobile">
                    <el-input  style="width:65%" v-model="resetMobileForm.resetMobile" ></el-input>
                    <el-button  type="primary" :disabled="resetMobileSmsFlag" @click="getSmsCode('resetMobile')" style="width:30%; float: right;">
                        {{resetMobileBtnTxt}}
                    </el-button>
                </el-form-item>

                <el-form-item label="验证码"  prop="smsCode">
                    <el-input v-model="resetMobileForm.smsCode" ></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelResetMobile()">取 消</el-button>
                <el-button type="primary" @click="doRetsetMobile()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 重绑手机号  end -->



        <!-- 修改提现配置 -->
        <el-dialog :append-to-body="true"  title="编辑提现配置" :visible.sync="editWithdrawalConfigDialog"  width="600px" @close="cancelEditWithdrawalConfig()" :close-on-click-modal="false">
            <el-form ref="editWithdrawalConfigForm" :model="editWithdrawalConfigForm" :rules="editWithdrawalConfigRules" label-width="120px">
                <el-form-item label="提现方式：">
                    <el-radio-group v-model="editWithdrawalConfigForm.cashType">
                        <el-radio :label="1">支付宝</el-radio>
                        <el-radio :label="2">银行卡</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="银行名称：" prop="bankName">
                    <el-input v-model="editWithdrawalConfigForm.bankName"  clearable></el-input>
                </el-form-item>

                <el-form-item label="收款账号：" prop="payeeAccount">
                    <el-input v-model="editWithdrawalConfigForm.payeeAccount"  clearable></el-input>
                </el-form-item>
                
                <el-form-item label="收款人姓名："  prop="payeeName">
                    <el-input v-model="editWithdrawalConfigForm.payeeName"  clearable></el-input>
                </el-form-item>

                <el-form-item label="收款人手机号：" prop="mobile">
                    <el-input v-model="editWithdrawalConfigForm.mobile"  clearable></el-input>
                </el-form-item>

                <el-form-item label="当前状态：" >
                    <el-radio-group v-model="editWithdrawalConfigForm.enable">
                        <el-radio :label="0">禁用</el-radio>
                        <el-radio :label="1">启用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEditWithdrawalConfig()">取 消</el-button>
                <el-button type="primary" @click="doSaveWithdrawalConfig()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改提现配置  end -->



        <!-- 修改登录密码 -->
        <el-dialog :append-to-body="true"  title="修改密码" :visible.sync="modifyPwdVisible"  width="600px" @close="cancelModifyPwd()" :close-on-click-modal="false">
            <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
                <el-form-item label="原密码：" prop="oldPwd">
                    <el-input v-model="modifyPwdForm.oldPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="新密码：" prop="newPwd">
                    <el-input v-model="modifyPwdForm.newPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="newPwdAgain"> 
                    <el-input v-model="modifyPwdForm.newPwdAgain" show-password clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelModifyPwd()">取 消</el-button>
                <el-button type="primary" @click="modifyPwd">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改登录密码  end -->


        <!-- 代理商修改支付/提现密码 -->
        <el-dialog :append-to-body="true"  title="修改提现密码" :visible.sync="changePaypassDialog"  width="600px" @close="cancelToChangePaypass()" :close-on-click-modal="false">
            <el-form :model="changePaypassForm" ref="changePaypassForm" :rules="changePaypassRules" label-width="120px" >
                <el-form-item  label="提现密码" prop="paypass" >
                    <el-input v-model="changePaypassForm.paypass" show-password clearable></el-input>
                </el-form-item>

                <el-form-item  label="再次确认密码" prop="confirmPaypass">
                    <el-input v-model="changePaypassForm.confirmPaypass" show-password clearable></el-input>
                </el-form-item>

                <el-form-item label="手机号"  prop="userPhone">
                    <el-input  style="width:65%" v-model="changePaypassForm.userPhone" disabled></el-input>
                    <el-button  type="primary" :disabled="smsFlag" @click="getSmsCode('changePaypass')" style="width:30%; float: right;">{{changePasswordBtnTxt}}</el-button>
                </el-form-item>

                <el-form-item label="验证码"  prop="smsCode">
                    <el-input v-model="changePaypassForm.smsCode" ></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelToChangePaypass()">取 消</el-button>
                <el-button type="primary" @click="doChangePaypass()">确 定</el-button>
            </span>
        </el-dialog> 
        <!-- 代理商修改支付/提现密码  end -->


    </div>
</template>
<script>
import common from '@/utils/common.js'
import {mapGetters } from "vuex";
export default {
    data(){
        let checkPwd = (rule, value, callback) => {
            if(value != this.modifyPwdForm.newPwd){
                return callback(new Error('两次输入密码不一致'))
            }
            callback();
        };

        let checkConfirmPaypass = (rule, value, callback) => {
            if(value != this.changePaypassForm.paypass){
                return callback(new Error('两次输入密码不一致'))
            }
            callback();
        };

        let checkBindPhone = (rule, value, callback) => {
            let pattern = new RegExp("[0-9]+");
            if(!pattern.test(value) || value.indexOf("1")!=0 || value.length!=11){
                return callback(new Error('请输入正确的手机号码'))
            }
            callback();
        };

        let checkSmsCode = (rule, value, callback) => {
            let pattern = new RegExp("[0-9]+");
            if(!pattern.test(value)){
                return callback(new Error('请输入正确的验证码'))
            }
            callback();
        };

        return {
            isAgent: localStorage.getItem('agentId') != 'null' && localStorage.getItem('agentId') != "",
            personalData:{
                name: null,
                accountName: null,
                bindMobile: null,
                pathNames: null,
            },

            //重绑手机号码
            resetMobiledialog: false,
            resetMobileForm:{
                resetMobile: null,
                smsCode: null,
            },
            resetMobileRules: {
                resetMobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: checkBindPhone, trigger: 'blur' }
                ],
                smsCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]
            },
            resetMobileBtnTxt: '获取验证码',
            //重绑手机号码 end

            /**  提现配置  **/
            withdrawalConfigData: [],
            editWithdrawalConfigDialog: false,
            editWithdrawalConfigForm:{
                id: null,
                bankName: null,
                enable: 1,
                mobile: null,
                payeeAccount: null,
                payeeName: null,
                cashType: 1,
            },
            editWithdrawalConfigRules:{
                bankName: { required: true, message: '请输入银行名称', trigger: 'blur' },
                mobile: { required: true, message: '请输入手机号', trigger: 'blur' },
                payeeAccount: { required: true, message: '请输入收款账号', trigger: 'blur' },
                payeeName: { required: true, message: '请输入收款人姓名', trigger: 'blur' },
            },
            /**  提现配置  end **/

            /** 修改登录密码  **/
            modifyPwdVisible:false,
            modifyPwdForm: {
                id: '',
                oldPwd: '',
                newPwd: '',
                newPwdAgain: ''
            },
            pwdRules: {
                newPwd: [
                    { required: true, message: '必填项', trigger: 'blur' }
                ],
                oldPwd: [
                    { required: true, message: '必填项', trigger: 'blur' }
                ],
                newPwdAgain: [
                    { required: true, message: '必填项', trigger: 'blur' }
                ],
            },
            /** 修改登录密码 end  **/
            

            //修改提现密码
            changePaypassDialog: false,
            changePasswordBtnTxt: '获取验证码',
            changePaypassForm:{
                paypass: null,
                confirmPaypass: null,
                userPhone: null,
                smsCode: null,
            },
            changePaypassRules: {
                paypass: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                confirmPaypass:[
                    { required: true, message: '请再次确认密码', trigger: 'blur' },
                    { validator: checkConfirmPaypass, trigger: 'blur' }
                ],
                bindMobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: checkBindPhone, trigger: 'blur' }
                ],
                smsCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { validator: checkSmsCode, trigger: 'blur' }
                ],
            },
            //修改提现密码  end

        }

    },
    methods: {

        /**  重绑手机号码  **/
        cancelResetMobile(){
            this.resetMobileForm.resetMobile = '';
            this.resetMobiledialog = false;
        },
        doRetsetMobile(){
            this.$refs.resetMobileForm.validate(valid => {
                if(valid) {
                    let data = {
                        bindMobile: this.resetMobileForm.resetMobile,
                        smsCode: this.resetMobileForm.smsCode,
                    }
                    common.sysRequest('agent/agent/mdy/info', data, 'post').then(res=>{
                        if(res.data.code == 200){
                            this.personalData.bindMobile = this.resetMobileForm.resetMobile;
                            this.changePaypassForm.userPhone = this.resetMobileForm.resetMobile;
                            this.$message.success(res.data.message);
                            this.cancelResetMobile();
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                        
                    });
                }
            });
        },
        /**  重绑手机号码  end **/


        /**  修改提现配置  end **/
        showEditWithdrawalConfig(config){
            if(config){
                for(let key in this.editWithdrawalConfigForm){
                    this.editWithdrawalConfigForm[key] = config[key];
                }

                this.editWithdrawalConfigForm.enable = config.enable?1:0;
            }
            this.editWithdrawalConfigDialog = true;
        },
        cancelEditWithdrawalConfig(){
            for(let key in this.editWithdrawalConfigForm){
                this.editWithdrawalConfigForm[key] = null;
            }
            this.editWithdrawalConfigDialog = false;
        },
        doSaveWithdrawalConfig(){
            this.$refs.editWithdrawalConfigForm.validate(valid => {
                if(valid) {
                    let path = 'agent/withdrawal/add';
                    if(this.editWithdrawalConfigForm.id != null){
                        path = 'agent/withdrawal/update'
                    }
                    common.sysRequest(path, this.editWithdrawalConfigForm, 'post').then(res=>{
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.cancelEditWithdrawalConfig();
                            this.getWithdrawalList();
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
                }
            });
        },
        deleteWithdrawalConfig(id){
            this.$confirm('确定要删除此配置吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                common.sysRequest('agent/withdrawal/delete/'+id, null, 'get').then(res=>{
                    if(res.data.code == 200){
                        this.getWithdrawalList();
                        this.$message.success(res.data.message);
                    }
                    else{
                        this.$message.error(res.data.message);
                    }
                });
            }).catch(() => {
      
            });
        },
        /**  修改提现配置  end **/


        /**  修改登录密码  **/
        cancelModifyPwd(){
            for(var key in this.modifyPwdForm){
                this.modifyPwdForm[key] = '';
            }
            this.$refs['modifyPwdForm'].resetFields();
            this.modifyPwdVisible = false;
        },
        modifyPwd(){
            this.$refs.modifyPwdForm.validate(valid => {
                if(valid) {
                    if(this.modifyPwdForm.newPwd != this.modifyPwdForm.newPwdAgain){
                        this.$message.error("两次输入的新密码不一致！");
                        return ;
                    }
                    this.modifyPwdForm.id = localStorage.getItem("id");
                    common.sysRequest('sysUser/updatePwd', this.modifyPwdForm, 'post').then(res => {  
                        let code = res.data.code;
                        if(code == 200){
                            this.$message.success('密码修改成功,请重新登录!');
                            let _self = this;
                            setTimeout(function(){
                                _self.$router.push('/');
                            }, 1000);
                        }else{
                            this.$message.error(res.data.message)
                        }
                        this.modifyPwdVisible = false;
                    })                    
                }
            })
        },
        /**  修改登录密码  end**/


        /**  修改提现密码  **/
        getSmsCode(actionName){
            if(actionName=="changePaypass"){
                common.sysRequest('/sms/send', {userPhone:this.changePaypassForm.userPhone}, 'post').then(res => {  
                    if(res.data.code == 200){
                        var n = 60;
                        this.changePasswordBtnTxt = n +'s后重新获取';
                        let timer = window.setInterval(() => {   
                            n--;                     
                            this.changePasswordBtnTxt = n +'s后重新获取';
                            if(n < 1){
                                window.clearInterval(timer);
                                this.changePasswordBtnTxt = '获取验证码';
                            }
                        },1000)
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            else if(actionName=="resetMobile"){
                common.sysRequest('/sms/send', {userPhone:this.resetMobileForm.resetMobile}, 'post').then(res => {  
                    if(res.data.code == 200){
                        var n = 60;
                        this.resetMobileBtnTxt = n +'s后重新获取';
                        let timer = window.setInterval(() => {   
                            n--;                     
                            this.resetMobileBtnTxt = n +'s后重新获取';
                            if(n < 1){
                                window.clearInterval(timer);
                                this.resetMobileBtnTxt = '获取验证码';
                            }
                        },1000)
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            
        },
        doChangePaypass(){
            this.$refs.changePaypassForm.validate(valid => {
                if(valid) {
                    let data = this.changePaypassForm;
                    data.bindMobile = this.changePaypassForm.userPhone;
                    common.sysRequest('/agent/agent/mdy/paypass', data, 'post').then(res=>{
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.cancelToChangePaypass();
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                        
                    });
                }
            });
        },

        cancelToChangePaypass(){
            for(let key in this.changePaypassForm){
                this.changePaypassForm[key] = null;
            }
            this.changePaypassForm.userPhone = this.personalData.bindMobile;
            this.changePaypassDialog = false;
        },
        /** 修改提现密码 end **/

        //获取提现配置列表
        getWithdrawalList(){
            common.sysRequest('agent/withdrawal/list', {}, 'post').then(res => {  
                if(res.data.code == 200){
                    this.withdrawalConfigData = res.data.data;
                }else{
                    this.$message.error(res.data.message);
                }
            });
        },
    },
    created(){
        //获取用户信息
        if(localStorage.getItem('agentId')!='null' && localStorage.getItem('agentId')!=''){
            common.sysRequest('agent/agent/info', null, 'get').then(res => {  
                if(res.data.code == 200){
                    this.personalData = res.data.data;
                    this.modifyPwdForm.id = res.data.data.id;
                    this.changePaypassForm.userPhone = res.data.data.bindMobile;
                }else{
                    this.$message.error(res.data.message);
                }
            });
        }
        

        
        this.getWithdrawalList();
    },

    computed: {
        resetMobileSmsFlag(){
            if(this.resetMobileForm.resetMobile && this.resetMobileForm.resetMobile.length == 11 && this.resetMobileBtnTxt == '获取验证码'){
                return false;
            }else{
                return true;
            }
        },

        smsFlag(){
            if(this.changePaypassForm.userPhone && this.changePaypassForm.userPhone.length == 11 && this.changePasswordBtnTxt == '获取验证码'){
                return false;
            }else{
                return true;
            }
        },

        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        }),

    },

}
</script>
<style lang="less" scoped>
#personalCenter {
    .section1{
        margin-left: 10px;

        h4 {
            font-size: 14px;
            font-weight: bold;
            padding-left: 5px;
            margin-top: 45px;
            margin-bottom: 20px;
            margin-left: -8px;
            border-left: 3px solid #409eff;            
        }

        >h4:first-child{
            margin-top: 0px;
        }

        label{
            display:inline-block;
        }
        .el-row{
            margin-bottom: 20px;
        }
        span{
            text-align:left;
        }
    }
}
</style>
